/**
 * Azure Blob Storage configuration for remote cache - uploading and downloading packages
 * via `cloudpack sync`.
 */
export interface RemoteCacheConfig {
  /**
   * The name of the Azure Blob Storage account.
   */
  storageAccount: string;
  /**
   * The name of the container to use for the remote cache. Container must already exist.
   */
  container: string;
  /**
   * The Microsoft Entra tenant (directory) ID. This will ensure that only users from this tenant can access the remote cache.
   */
  tenantId?: string;
}
